export enum DrawingParametersEnum {
    allon = "allon",
    compact = "compact",
    compacttight = "compacttight",
    default = "default",
    leadsheet = "leadsheet",
    preview = "preview",
    thumbnail = "thumbnail",
}
// note that this is moved here from DrawingParameters to prevent an import chain from OSMDOptions to EngravingRules etc
